import React from 'react';
import PropTypes from 'prop-types';

const TwineLogoIcon = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 280 320.5"
    fill="#fff"
    aria-hidden="true"
  >
    <path d="M59.7 195.8c-19.2-19.2-19.7-50.2-1.4-70l2.8-2.8c17.6-16.4 45-16.4 62.5.2l51.8 51.8c7 7 18.4 7 25.4 0 6.9-6.9 7-18.1.2-25.1l-55-55c-15.7-15.7-15.7-41.2 0-56.9l5.4-5.4c6-6 6-15.8 0-21.8-5.9-5.9-15.2-6-21.3-.5l-.5.5L97 43.5 34.5 106c-29.7 29.7-29.7 78.4 0 108.1l52 52c6 6 15.8 6 21.8 0s6-15.8 0-21.8l-48.6-48.5z" />
    <path d="M245.6 107.2 226.5 88l-32.8-32.8c-6-6-15.8-6-21.8 0s-6 15.8 0 21.8l48.4 48.5c17.7 17.6 19.5 45.3 5.4 65-1.6 2.2-3.3 4.4-5.3 6.4-18 18-47.2 18-65.2 0l-49.4-49.4c-7-7-18.4-7-25.4 0-6.9 6.9-7 18.1-.2 25.1l52.8 52.8c16.3 16.3 16.3 42.8 0 59.1l-4.3 4.3c-6 6-6 15.8 0 21.8 5.9 5.9 15.5 6 21.6.2l.2-.2 32.8-32.8 62.5-62.5c29.5-29.8 29.5-78.4-.2-108.1z" />
  </svg>
);

TwineLogoIcon.propTypes = {
  size: PropTypes.number.isRequired,
};

const AriAvatar = ({ size = 32, className }) => (
  <span
    className={className}
    style={{ width: size, height: size }}
    role="img"
    aria-label="Ari"
  >
    <TwineLogoIcon size={Math.round(size * 0.52)} />
  </span>
);

AriAvatar.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default AriAvatar;
